import { RouteObject } from "react-router-dom"
import { listAndDetailSamplesRoutes } from "../../ListAndDetailSamplesNavigation"
import { ListAndDetailSamplesMultipleList2EditPage } from "./ListAndDetailSamplesMultipleList2EditPage"
import { ListAndDetailSamplesMultipleList3EditPage } from "./ListAndDetailSamplesMultipleList3EditPage"
import { ListAndDetailSamplesMultipleListsPage } from "./ListAndDetailSamplesMultipleListsPage"
import { ListAndDetailSamplesMultipleList1EditPage } from "./ListAndDetailSamplesMultipleList1EditPage"

// Allow in same file
// eslint-disable-next-line
export const list1Routes = {
    new: "new",
    edit: "list1/",
    match: ":code1"
}

// Allow in same file
// eslint-disable-next-line
export const list2Routes = {
    new: "new",
    edit: "list2/",
    match: ":code2"
}

// Allow in same file
// eslint-disable-next-line
export const list3Routes = {
    new: "new",
    edit: "edit/",
    match: ":code3"
}

// Allow in same file
// eslint-disable-next-line
export const list1RoutesCombined = () => {
    return {
        list_editMatch: `${listAndDetailSamplesRoutes.multipleLists}/${list1Routes.edit}${list1Routes.match}`
    }
}

// Allow in same file
// eslint-disable-next-line
export const list2RoutesCombined = (list1Match?: string) => {
    return {
        list: `${listAndDetailSamplesRoutes.multipleLists}/${list1Routes.edit}${list1Match}`,
        list_editMatch: `${list1RoutesCombined().list_editMatch}/${list2Routes.edit}${list2Routes.match}`,
        new: `${list1RoutesCombined().list_editMatch}/${list2Routes.new}`
    }
}

// Allow in same file
// eslint-disable-next-line
export const list3RoutesCombined = (list1Match?: string, list2Match?: string) => {
    return {
        list: `${list2RoutesCombined(list1Match).list}/${list2Routes.edit}${list2Match}`,
        list_editMatch: `${list2RoutesCombined().list_editMatch}/${list3Routes.edit}${list3Routes.match}`,
        new: `${list2RoutesCombined().list_editMatch}/${list2Routes.new}`
    }
}

export const MultipleListsNavigation = (): RouteObject[] => {
    return [
        {
            path: listAndDetailSamplesRoutes.multipleLists,
            element: <ListAndDetailSamplesMultipleListsPage />,
            children: [
                {
                    path: `${list1Routes.new}`,
                    element: <ListAndDetailSamplesMultipleList1EditPage />,
                },
                {
                    path: `${list1Routes.edit}${listAndDetailSamplesRoutes.matchId}`,
                    element: <ListAndDetailSamplesMultipleList1EditPage />,
                    children: [...List2ChildrenNavigation()]
                }
            ]
        }
    ]
}

export const List2ChildrenNavigation = (): RouteObject[] => {
    return [
        {
            path: `${list2Routes.new}`,
            element: <ListAndDetailSamplesMultipleList2EditPage />
        },
        {
            path: `${list2Routes.edit}${list2Routes.match}`,
            element: <ListAndDetailSamplesMultipleList2EditPage />,
            children: [...List3ChildrenNavigation()]
        }
    ]
}

const List3ChildrenNavigation = (): RouteObject[] => {
    return [
        {
            path: `${list3Routes.new}`,
            element: <ListAndDetailSamplesMultipleList3EditPage />
        },
        {
            path: `${list3Routes.edit}${list3Routes.match}`,
            element: <ListAndDetailSamplesMultipleList3EditPage />
        }
    ]
}
